export default __webpack_public_path__ + "static/media/send-grid.93a98285.webp";